"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isCurrentUserRegisteredNew = function isCurrentUserRegisteredNew(_ref) {
  var challenge = _ref.challenge,
      userChallenge = _ref.userChallenge;

  if (!challenge) {
    return false;
  }

  var _challenge$groupChall = challenge.groupChallenge;
  _challenge$groupChall = _challenge$groupChall === void 0 ? {} : _challenge$groupChall;
  var _challenge$groupChall2 = _challenge$groupChall.isCurrentUserRegistered,
      isCurrentUserRegistered = _challenge$groupChall2 === void 0 ? false : _challenge$groupChall2;
  return Boolean(userChallenge) || !!isCurrentUserRegistered;
};

var _default = isCurrentUserRegisteredNew;
exports["default"] = _default;
//# sourceMappingURL=isCurrentUserRegisteredNew.js.map